import { Eye, Pencil } from "lucide-react"
import { Button } from "@/components/ui/button"
import { SectionCard } from "@/components/ui/section-card"

export function SecaoObservacoes() {
  return (
    <SectionCard className="p-4">
      <div className="flex items-start justify-between gap-2 mb-3">
        <div className="flex flex-col gap-0.5">
          <h3 className="text-white text-xl font-bold">Observações</h3>
          <p className="text-[#d1d1d1] text-xs font-normal">
            Apresentar qualquer informação relevante para a análise deste
            demonstrativo e da prestação de contas do projeto
          </p>
        </div>
        <div className="flex items-center gap-1.5 p-1.5 rounded-3xl">
          <Button
            variant="ghost"
            size="icon"
            aria-label="Visualizar observações"
            className="h-5 w-5 p-0 text-gray-400 hover:text-green-400 hover:bg-green-500/10"
          >
            <Eye className="w-4 h-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            aria-label="Editar observações"
            className="h-5 w-5 p-0 text-gray-400 hover:text-blue-400 hover:bg-blue-500/10"
          >
            <Pencil className="w-4 h-4" />
          </Button>
        </div>
      </div>
      <div className="text-xs leading-[1.2] text-[#f6f6f6] font-normal h-20 overflow-hidden">
        <p>
          Lorem ipsum dolor sit amet consectetur. Placerat facilisi vitae lacus
          lorem potenti sagittis etiam. Sit ut pharetra sapien eu. Tortor
          adipiscing integer nisl donec vitae rhoncus arcu amet.
        </p>
        <p className="mt-2">
          Porttitor id amet vel integer scelerisque sollicitudin euismod. Neque
          ut gravida id aliquet nulla pellentesque sollicitudin at.
        </p>
      </div>
    </SectionCard>
  )
}
